// extracted by mini-css-extract-plugin
module.exports = {"container":"_2sAAl","expand":"_1ptI_"};